import React, {Component} from "react"

import Selector from "../../../components/global/Selector/Selector"

export default class OurPeople extends Component {
  constructor(props){
    super(props);
    this.state = {
      data: [],
    }
  }

  componentDidMount() {
    this.setState({ data: this.props.data })
  }

  render() {

    return(
      <section className="flex">
        <Selector subSelector items={this.state.data} />
      </section>
    )
  }
}
